module.exports = __webpack_public_path__ + "static/media/TheGhostsofBitterflyBay.3b9f108c.jpg";